/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import {BrowserRouter, Route} from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './Assets/css/styles_admin.css'
import './Assets/css/style.css'
import './Assets/js/scripts'
import Home from './Components/Pages/Home'
import Nav from "./Components/Include/Nav";
import SideBar from "./Components/Include/SideBar";
import Footer from "./Components/Include/Footer";
import FooterLink from "./Components/Pages/FooterLink/FooterLink";
import AppointmentList from "./Components/Pages/Appointment/AppointmentList"
import CreateTruck from "./Components/Pages/Truck/CreateTruck";
import Truck from "./Components/Pages/Truck/Truck";
import Login from "./Components/Pages/Login";
import {useEffect, useState} from "react";
import Auth from "./Auth";
import AppointmentDetails from "./Components/Pages/Appointment/AppointmentDetails";
import Schedule from "./Components/Pages/Schedule/Schedule";
import CustomerList from "./Components/Pages/Customer/CustomerList";
import Report from "./Components/Pages/Report/Report";
import Service from "./Components/Pages/Services/Service";
import ServiceProviderList from "./Components/Pages/ServiceProvider/ServiceProviderList";
import OrderList from "./Components/Pages/Order/OrderList";
import ServiceProviderDetails from "./Components/Pages/ServiceProvider/ServiceProviderDetails";

function App() {
    const [url, setUrl] = useState('')
    useEffect(() => {
        setUrl(window.location.pathname)
        console.log(url)
    }, [])
    return (
        <>
            {url == '/login' ?
                <BrowserRouter>
                    <Route path={'/login'} component={Login}/>
                </BrowserRouter> :
                <BrowserRouter>
                    <Nav/>
                    <div id="layoutSidenav">
                        <SideBar/>
                        <div id="layoutSidenav_content">
                            <Auth path={'/example'} component={Home}/>
                            <Auth exact path={'/'} component={Home}/>
                            <Auth path={'/service'} component={Service}/>
                            <Auth path={'/service-provider'} component={ServiceProviderList}/>
                            <Auth path={'/service-provider-details/:id'} component={ServiceProviderDetails}/>
                            <Auth path={'/order-list'} component={OrderList}/>
                            <Auth path={'/customer-list'} component={CustomerList}/>
                            <Auth path={'/report'} component={Report}/>
                            <Footer/>
                        </div>
                    </div>
                </BrowserRouter>
            }
        </>
    );
}

export default App;
